import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import secureAxios from "../utils/secureAxios";
import { getApiBaseURL } from "../utils/api";

const SetNewPassword = () => {
  const { user_id } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const apiBase = getApiBaseURL();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirm) {
      setMessage("❌ Passwords do not match");
      return;
    }

    try {
      await secureAxios.post(`${apiBase}/api/auth/set-new-password`, {
        user_id,
        password,
      });
      setMessage("✅ Password updated successfully!");
      setTimeout(() => navigate("/"), 1500);
    } catch (err) {
      console.error("❌ Error resetting password", err);
      setMessage("❌ Failed to update password.");
    }
  };

  return (
    <div className="container mt-5">
      <h3>Set New Password</h3>
      {message && <p className="fw-bold">{message}</p>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">New Password</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Confirm Password</label>
          <input
            type="password"
            className="form-control"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
        </div>
        <button className="btn btn-primary" type="submit">
          Set Password
        </button>
      </form>
    </div>
  );
};

export default SetNewPassword;
